/* ============================================================
   dbakers Macaron Builder JS
   - Tap flavor card → adds 1 to box (or shakes if box full)
   - Tap swatch in box → removes that one
   - Pick mine / Surprise me toggle
   - Cart submit with flavor list as line item property
   - ADA: aria-live updates, keyboard support, focus management
   ============================================================ */

(function () {
  'use strict';

  if (!document.getElementById('dmb-root')) return;

  var CFG = window.dmbConfig || {};
  var BOX_SIZE = CFG.boxSize || 6;

  /* ── State ──
     box: ordered array of flavors in the box (chronological).
          Each entry is the canonical flavor name string.
     mode: 'pick' or 'auto' (auto = Bestsellers on box of 6, Assorted on box of 12) */
  var state = {
    mode: 'pick',
    box: []
  };

  /* Cache flavor metadata from the DOM so JS doesn't duplicate the list */
  var FLAVORS = {};
  document.querySelectorAll('.dmb-flavor-card').forEach(function (card) {
    var slug = card.dataset.flavorSlug;
    var name = card.dataset.flavor;
    if (slug && name) FLAVORS[slug] = name;
  });

  /* ── Init ── */
  function init() {
    bindModeToggle();
    bindFlavorCards();
    bindBoxClear();
    bindStickyBtn();
    bindUpgrades();
    render();
  }

  if (document.readyState === 'complete') {
    setTimeout(init, 100);
  } else {
    window.addEventListener('load', function () { setTimeout(init, 100); });
  }

  /* ── Mode toggle ──
     - Box of 6, "auto" mode  = "Bestsellers": auto-fill the visible box
       with top 6 picks, customer can swap individual macarons.
     - Box of 12, "auto" mode = "Assorted": hide the box-viz, show the
       baker's-choice card. Cart sends "Baker's choice (assorted)". */
  function bindModeToggle() {
    document.querySelectorAll('.dmb-mode-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = this.dataset.mode;
        if (state.mode === mode) return;
        var prevMode = state.mode;
        state.mode = mode;

        document.querySelectorAll('.dmb-mode-btn').forEach(function (b) {
          var active = b.dataset.mode === mode;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-checked', String(active));
        });

        var pickPanel     = document.getElementById('dmb-pick-panel');
        var assortedPanel = document.getElementById('dmb-assorted-panel'); /* only on box of 12 */

        if (mode === 'pick') {
          if (pickPanel)     pickPanel.hidden = false;
          if (assortedPanel) assortedPanel.hidden = true;
          /* Switching from auto-fill back to Pick mine clears the box
             on box of 6 — they explicitly chose to pick their own. */
          if (BOX_SIZE === 6 && prevMode === 'auto') {
            state.box = [];
            announce('Box cleared. Pick your flavors.');
          }
        } else if (mode === 'auto') {
          if (BOX_SIZE === 6) {
            /* Box of 6: auto-fill visible box with bestsellers, can swap */
            if (pickPanel)     pickPanel.hidden = false;
            if (assortedPanel) assortedPanel.hidden = true;
            autoFillBox();
          } else {
            /* Box of 12: black-box assorted, hide pick panel */
            if (pickPanel)     pickPanel.hidden = true;
            if (assortedPanel) assortedPanel.hidden = false;
            announce("Baker's choice assorted box selected.");
          }
        }
        render();
      });
    });
  }

  /* Auto-fill the box with top bestsellers (box of 6 only). */
  function autoFillBox() {
    var ranking = CFG.bestsellers6 || [];
    state.box = ranking.slice(0, BOX_SIZE);
    announce('Box auto-filled with bestsellers. Tap a macaron in your box to swap it.');
  }


  /* ── Flavor cards (tap to add) ── */
  function bindFlavorCards() {
    document.querySelectorAll('.dmb-flavor-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addFlavor(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          addFlavor(card);
        }
      });
    });
  }

  function addFlavor(card) {
    var slug = card.dataset.flavorSlug;
    var name = card.dataset.flavor;
    if (!slug || !name) return;

    /* Box full — shake the card and bail */
    if (state.box.length >= BOX_SIZE) {
      card.classList.remove('is-shaking');
      /* force reflow to restart the animation */
      void card.offsetWidth;
      card.classList.add('is-shaking');
      setTimeout(function () { card.classList.remove('is-shaking'); }, 400);
      announce('Your box is full. Tap a macaron to remove it first, or try the ' + (CFG.otherBoxLabel || 'other box') + '.');
      return;
    }

    state.box.push(slug);
    render();
    announce(name + ' added. ' + state.box.length + ' of ' + BOX_SIZE + '.');
  }

  /* ── Box clear ── */
  function bindBoxClear() {
    var btn = document.getElementById('dmb-box-clear');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (state.box.length === 0) return;
      state.box = [];
      render();
      announce('Box cleared.');
    });
  }

  /* ── Box slot click (tap to remove) ──
     Bound dynamically inside render() since slots get rebuilt each time. */
  function bindBoxSlot(slot, slotSlug, slotIndex) {
    function removeAtSlot() {
      /* Remove the macaron at this slot index from state.box */
      if (slotIndex < state.box.length) {
        var removed = state.box.splice(slotIndex, 1)[0];
        var name = FLAVORS[removed] || 'Macaron';
        render();
        announce(name + ' removed. ' + state.box.length + ' of ' + BOX_SIZE + '.');
      }
    }
    slot.addEventListener('click', removeAtSlot);
    slot.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        removeAtSlot();
      }
    });
  }

  /* ── Sticky button (Add to cart) ── */
  function bindStickyBtn() {
    var btn = document.getElementById('dmb-sticky-btn');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      submitCart();
    });
  }

  /* ── Upgrades (Make it special) — gift message only on macarons. ── */
  function bindUpgrades() {
    document.querySelectorAll('.dmb-addon-row').forEach(function (row) {
      row.addEventListener('click', function () {
        var card = row.closest('.dmb-addon-card');
        if (!card) return;
        var nowActive = !card.classList.contains('is-active');
        card.classList.toggle('is-active', nowActive);
        row.setAttribute('aria-expanded', String(nowActive));
        var panelId = row.getAttribute('aria-controls');
        if (panelId) {
          var panel = document.getElementById(panelId);
          if (panel) panel.hidden = !nowActive;
        }
      });
      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          row.click();
        }
      });
    });
  }

  /* ── Render — full re-render of dynamic UI from state ── */
  function render() {
    renderBoxSlots();
    renderBoxCount();
    renderFlavorBadges();
    renderFlavorDisabled();
    renderClearBtn();
    renderStickyBar();
    renderUpsell();
    renderBoxHint();
    renderFlavorsSection();
  }

  /* ── Tap-to-remove hint inside the box card ──
     Shown when box has at least 1 macaron — no point showing the hint
     when there's nothing to remove. */
  function renderBoxHint() {
    var el = document.getElementById('dmb-box-hint');
    if (!el) return;
    el.hidden = state.box.length === 0;
  }

  /* ── Hide flavor grid when box is full ──
     Customer is done picking; collapsing the grid removes visual noise
     and gently signals "you're set." Reappears smoothly if they remove
     a macaron. Disabled in 'auto' mode for box of 12 (which uses the
     bakery-assorted black-box card and never shows the grid anyway). */
  function renderFlavorsSection() {
    var section = document.getElementById('dmb-flavors-section');
    if (!section) return;
    var ready = state.box.length === BOX_SIZE;
    section.classList.toggle('is-collapsed', ready);
    section.setAttribute('aria-hidden', ready ? 'true' : 'false');
  }

  function renderBoxSlots() {
    var slotsEl = document.getElementById('dmb-box-slots');
    if (!slotsEl) return;
    slotsEl.innerHTML = '';

    /* Helper — builds the heart SVG used in empty slots. */
    function makeHeartSvg() {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'dmb-empty-heart');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M12 21s-7-4.5-9.5-9C1 9 2.5 5 6 5c2 0 3.5 1 4.5 2.5C11.5 6 13 5 15 5c3.5 0 5 4 3.5 7-2.5 4.5-9.5 9-9.5 9z');
      svg.appendChild(path);
      return svg;
    }

    /* Filled slots (chronological) — actual macaron PNG inside a cream pill.
       If a flavor has no image (seasonals without uploaded photos), fall back
       to the color swatch so something visual still shows. */
    state.box.forEach(function (slug, index) {
      var card = document.querySelector('.dmb-flavor-card[data-flavor-slug="' + cssEscape(slug) + '"]');
      var slot = document.createElement('div');
      slot.className = 'dmb-box-slot is-filled';
      slot.tabIndex = 0;
      slot.setAttribute('role', 'button');
      var name = FLAVORS[slug] || 'Macaron';
      slot.setAttribute('aria-label', name + ', tap to remove');

      if (card) {
        var imgWrap = card.querySelector('.dmb-flavor-img');
        if (imgWrap) {
          var img = imgWrap.querySelector('img');
          if (img) {
            /* Real product image — clone it into the slot. The .is-filled
               class provides the cream pill background via CSS. */
            var slotImg = document.createElement('img');
            slotImg.src = img.src;
            slotImg.alt = '';
            slot.appendChild(slotImg);
          } else {
            /* No image — show the color swatch as the slot background
               so the customer still sees what they picked. */
            slot.style.background = imgWrap.style.background || '';
          }
        }
      }

      bindBoxSlot(slot, slug, index);
      slotsEl.appendChild(slot);
    });

    /* Empty slots — dashed pill outline + faded heart silhouette */
    for (var i = state.box.length; i < BOX_SIZE; i++) {
      var emptySlot = document.createElement('div');
      emptySlot.className = 'dmb-box-slot is-empty';
      emptySlot.setAttribute('aria-label', 'Empty slot ' + (i + 1));
      emptySlot.appendChild(makeHeartSvg());
      slotsEl.appendChild(emptySlot);
    }
  }

  function renderBoxCount() {
    var el = document.getElementById('dmb-box-count');
    if (el) el.textContent = state.box.length + ' of ' + BOX_SIZE + ' macarons';
  }

  function renderFlavorBadges() {
    /* Count how many of each slug are in the box */
    var counts = {};
    state.box.forEach(function (slug) {
      counts[slug] = (counts[slug] || 0) + 1;
    });
    document.querySelectorAll('.dmb-flavor-card').forEach(function (card) {
      var slug = card.dataset.flavorSlug;
      var n = counts[slug] || 0;
      var badge = card.querySelector('.dmb-flavor-badge');
      if (badge) {
        badge.textContent = n;
        badge.hidden = n === 0;
      }
      card.classList.toggle('is-selected', n > 0);
      card.setAttribute('aria-pressed', n > 0 ? 'true' : 'false');
    });
  }

  function renderFlavorDisabled() {
    /* When box is full, flavors NOT already in the box should look disabled.
       But if a flavor IS in the box, keep it interactive — they may want
       to swap or tap-to-remove (we don't currently support tap-card-to-
       remove, but visually it should look "active" not "disabled"). */
    var full = state.box.length >= BOX_SIZE;
    document.querySelectorAll('.dmb-flavor-card').forEach(function (card) {
      var slug = card.dataset.flavorSlug;
      var inBox = state.box.indexOf(slug) !== -1;
      card.classList.toggle('is-disabled', full && !inBox);
    });
  }

  function renderClearBtn() {
    var btn = document.getElementById('dmb-box-clear');
    if (btn) btn.disabled = state.box.length === 0;
  }

  function renderStickyBar() {
    var countEl = document.getElementById('dmb-sticky-count');
    var priceEl = document.getElementById('dmb-sticky-price');
    var btn     = document.getElementById('dmb-sticky-btn');

    var priceLabel = formatMoney(CFG.boxPrice || 0);

    /* Box of 12 in "auto" (assorted) mode — bakery picks, ATC always ready */
    var isAssortedBox12 = state.mode === 'auto' && BOX_SIZE === 12;

    if (isAssortedBox12) {
      if (countEl) {
        countEl.innerHTML = "Baker's assorted dozen <span aria-hidden=\"true\">✓</span>";
        countEl.classList.add('is-ready');
      }
      if (priceEl) priceEl.textContent = '12 macarons · ' + priceLabel;
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      }
      return;
    }

    /* Pick mine OR Bestsellers (box of 6) — count-as-hero pattern */
    var ready = state.box.length === BOX_SIZE;
    var remaining = BOX_SIZE - state.box.length;

    if (countEl) {
      if (ready) {
        countEl.innerHTML = 'Box ready <span aria-hidden="true">✓</span>';
        countEl.classList.add('is-ready');
      } else if (remaining === 1) {
        countEl.innerHTML = '<strong>1 macaron</strong> left';
        countEl.classList.remove('is-ready');
      } else {
        countEl.innerHTML = '<strong>' + remaining + ' macarons</strong> left';
        countEl.classList.remove('is-ready');
      }
    }

    if (priceEl) {
      if (ready) {
        priceEl.textContent = BOX_SIZE + ' macarons · ' + priceLabel;
      } else {
        priceEl.textContent = priceLabel + ' · pick to continue';
      }
    }

    if (btn) {
      btn.disabled = !ready;
      btn.textContent = 'Add to cart';
    }
  }

  function renderUpsell() {
    var el = document.getElementById('dmb-upsell');
    if (!el) return;
    /* Show upsell when picking and box is full — link to the OTHER box size */
    var show = state.mode === 'pick' && state.box.length === BOX_SIZE;
    el.hidden = !show;
  }

  /* ── Cart submit ── */
  function submitCart() {
    var btn = document.getElementById('dmb-sticky-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    var props = {};
    var isAssortedBox12 = state.mode === 'auto' && BOX_SIZE === 12;

    if (isAssortedBox12) {
      props['Flavors']   = "Baker's choice (assorted)";
      props['Selection'] = "Baker's assorted dozen";
    } else {
      /* Aggregate counts per flavor → "Pistachio ×2, Raspberry ×1, Salted Caramel ×1" */
      var counts = {};
      state.box.forEach(function (slug) {
        var name = FLAVORS[slug] || slug;
        counts[name] = (counts[name] || 0) + 1;
      });
      var parts = [];
      Object.keys(counts).forEach(function (name) {
        parts.push(name + ' ×' + counts[name]);
      });
      props['Flavors'] = parts.join(', ');

      /* Tag auto-fill orders so the bakery knows it's a bestseller box */
      if (state.mode === 'auto' && BOX_SIZE === 6) {
        props['Selection'] = 'Bestsellers (assorted)';
      }
    }

    /* Gift message — only attach if the addon is enabled AND non-empty */
    var giftCard = document.getElementById('dmb-addon-card-gift');
    if (giftCard && giftCard.classList.contains('is-active')) {
      var giftText = (document.getElementById('dmb-gift-text') || {}).value || '';
      giftText = giftText.trim();
      if (giftText) props['Gift message'] = giftText;
    }

    var item = {
      id: CFG.variantId,
      quantity: 1,
      properties: props
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        if (btn) { btn.textContent = 'Add to cart'; btn.disabled = false; }
        alert('Something went wrong: ' + (data.description || 'Please try again.'));
        return;
      }
      onCartSuccess(btn);
    })
    .catch(function (err) {
      console.error('dmb cart error:', err);
      if (btn) { btn.textContent = 'Add to cart'; btn.disabled = false; }
    });
  }

  function onCartSuccess(btn) {
    if (btn) btn.textContent = 'Added! ✓';
    setTimeout(function () {
      if (btn) {
        var isAssortedBox12 = state.mode === 'auto' && BOX_SIZE === 12;
        var ready = isAssortedBox12 || state.box.length === BOX_SIZE;
        btn.textContent = 'Add to cart';
        btn.disabled = !ready;
      }
    }, 2000);

    /* Notify Dawn to refresh the cart drawer / badge */
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:change',  { bubbles: true }));
  }

  /* ── Helpers ── */
  function announce(msg) {
    var el = document.getElementById('dmb-sticky-live');
    if (el) el.textContent = msg;
  }

  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  /* CSS escape — for selectors built from data attributes.
     CSS.escape is widely supported but we polyfill defensively. */
  function cssEscape(s) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_-]/g, function (c) {
      return '\\' + c.charCodeAt(0).toString(16) + ' ';
    });
  }

  /* ── Cart badge updater (shared with cake builders) ── */
  var EVENTS = ['cart:refresh', 'cart:change', 'cart:update', 'cart-update'];
  var lastCount = -1;
  function refreshBadge() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = 0;
        cart.items.forEach(function (item) {
          var isAddon = false;
          if (item.properties) {
            Object.keys(item.properties).forEach(function (key) {
              if (key === '_addon' || key === '_addon_for') isAddon = true;
            });
          }
          if (!isAddon) count += item.quantity;
        });
        if (count === lastCount) return;
        lastCount = count;
        document.querySelectorAll('.dbn-cart-badge').forEach(function (el) {
          el.textContent = count;
          el.style.display = count > 0 ? '' : 'none';
        });
        document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden)').forEach(function (el) {
          el.textContent = count;
        });
      })
      .catch(function () { /* silent */ });
  }
  if (document.readyState === 'complete') refreshBadge();
  else window.addEventListener('load', refreshBadge);
  EVENTS.forEach(function (evt) { document.addEventListener(evt, refreshBadge); });

})();